import { HelpCircle, Search } from "lucide-react";
import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type Tab = "browse" | "stats";

type Props = {
  tab: Tab;
  total?: number;
  totalWord?: string;
  q?: string;
  onQChange?: (v: string) => void;
  showSearch?: boolean;
  actions?: ReactNode;
  children: ReactNode;
};

export default function CommentsPageShell({
  tab,
  total,
  totalWord = "komentarzy",
  q = "",
  onQChange,
  showSearch = false,
  actions,
  children,
}: Props) {
  return (
    <div className={cn("comments-page -mx-8 -my-8 min-h-screen")}>
      <header className="border-b border-slate-200 bg-white px-6 py-6 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900">Komentarze</h1>
              <p className="mt-1 max-w-xl text-sm text-slate-600">
                Głos spod rolek: IG i FB na żywo, YT i TT z dumpów. Narzędzia pod karuzele, nie
                skrzynka do odpowiedzi.
                <span
                  className="ml-1 inline-flex align-middle text-slate-400"
                  title="To komentarze publiczne pod rolkami, nie prywatne DM."
                >
                  <HelpCircle className="h-3.5 w-3.5" />
                </span>
              </p>
              <div className="mt-4 inline-flex rounded-lg border border-slate-200 bg-slate-50 p-1">
                <NavLink
                  to="/komentarze"
                  end
                  className={({ isActive }) =>
                    cn(
                      "rounded-md px-3 py-1.5 text-sm font-medium",
                      isActive || tab === "browse"
                        ? "bg-white text-slate-900 shadow-sm"
                        : "text-slate-500 hover:text-slate-800",
                    )
                  }
                >
                  Przeglądarka
                </NavLink>
                <NavLink
                  to="/komentarze/statystyki"
                  className={({ isActive }) =>
                    cn(
                      "rounded-md px-3 py-1.5 text-sm font-medium",
                      isActive || tab === "stats"
                        ? "bg-white text-slate-900 shadow-sm"
                        : "text-slate-500 hover:text-slate-800",
                    )
                  }
                >
                  Statystyki
                </NavLink>
              </div>
            </div>
            <div className="flex w-full max-w-md flex-col items-stretch gap-3 sm:items-end">
              <div className="flex items-center justify-end gap-3">
                {actions}
                {total != null && !showSearch && (
                  <div className="shrink-0 text-sm font-medium text-slate-600">
                    {total} <span className="text-slate-400">{totalWord}</span>
                  </div>
                )}
              </div>
              {showSearch && onQChange && (
                <div className="flex w-full items-center gap-3">
                  <div className="relative flex-1">
                    <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                    <Input
                      className="border-slate-200 bg-slate-50 pl-9 text-slate-900 placeholder:text-slate-400"
                      placeholder="Szukaj w treści, autorze, tytule rolki…"
                      value={q}
                      onChange={(e) => onQChange(e.target.value)}
                    />
                  </div>
                  {total != null && (
                    <div className="shrink-0 text-sm font-medium text-slate-600">
                      {total} <span className="text-slate-400">{totalWord}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-6xl px-6 py-6 lg:px-8">{children}</div>
    </div>
  );
}
